export default __webpack_public_path__ + "static/media/pathfinder.f70bc591.png";